import { preload } from 'react-dom'

import styles from './ResponsiveImage.module.scss'

// 1x1 transparent GIF inlined in the HTML - at `hiddenMedia` the browser "loads" this instead of the real file
const TRANSPARENT_PIXEL =
  'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'

type ResponsiveImageProps = Omit<
  React.ImgHTMLAttributes<HTMLImageElement>,
  'src' | 'loading' | 'fetchPriority'
> & {
  src: string
  alt: string
  visibleMedia: string
  hiddenMedia: string
  priority?: boolean
}

// <img> downloaded (and with `priority` preloaded) only where `visibleMedia` matches.
// Both variants are always rendered (CSS toggles them), so the server cannot pick one.
const ResponsiveImage = ({
  visibleMedia,
  hiddenMedia,
  priority,
  src,
  alt,
  ...imgProps
}: ResponsiveImageProps) => {
  if (priority) {
    preload(src, { as: 'image', fetchPriority: 'high', media: visibleMedia })
  }

  return (
    <picture className={styles.picture}>
      <source media={hiddenMedia} srcSet={TRANSPARENT_PIXEL} />
      <img
        {...imgProps}
        src={src}
        alt={alt}
        loading={priority ? 'eager' : 'lazy'}
        fetchPriority={priority ? 'high' : 'low'}
      />
    </picture>
  )
}

export default ResponsiveImage
